import { ECustomerType } from '@webtrader/core/api/account/signUp';
import { EDataTestId } from '@webtrader/core/constants/test';
import i18n from '@webtrader/core/i18n';

export const ACCOUNT_TYPE_OPTIONS = [
  {
    label: i18n.t('Individual'),
    value: ECustomerType.INDIVIDUAL,
    testID: EDataTestId.ACCOUNT_TYPE_OPTIONS
  },
  {
    label: i18n.t('Corporate'),
    value: ECustomerType.CORPORATE,
    testID: EDataTestId.ACCOUNT_TYPE_OPTIONS
  }
];
